<template>
  <div class="portfolio-case-study container" id="days-of-dante">
    <CsVideoIntro v-bind="project.caseStudy.intro"></CsVideoIntro>
    <CsSynopsis v-bind="project.caseStudy.synopsis"></CsSynopsis>
    <CsVideoReel :video="project.caseStudy.fullVideo" />
    <CsShowcase v-bind="project.caseStudy.showcase"></CsShowcase>
    <CsImageGrid v-bind="project.caseStudy.imageGrid"></CsImageGrid>
    <CallToAction v-bind="cta" />
  </div>
</template>

<script>
import { daysOfDante, cta } from "@/data/projects.js";
import CallToAction from "@/components/CallToAction";
import CsVideoIntro from "@/components/CsVideoIntro/CsVideoIntro";
import CsSynopsis from "@/components/CsSynopsis/CsSynopsis";
import CsShowcase from "@/components/CsShowcase/CsShowcase";
import CsImageGrid from "@/components/CsImageGrid/CsImageGrid";
import CsVideoReel from "@/components/CsVideoReel/CsVideoReel";

export default {
  name: "DaysOfDante",
  metaInfo: {
    title: `100 Days Of Dante`,
    meta: [
      {
        name: "description",
        content: `100 Days of Dante is the world's largest dante reading group. A collaborative resource aimed at educating and forming readers of Dante's Divine Comedy.`,
      },
    ],
  },
  data() {
    return {
      project: daysOfDante,
      cta: cta,
    };
  },
  components: {
    CallToAction,
    CsVideoIntro,
    CsSynopsis,
    CsShowcase,
    CsImageGrid,
    CsVideoReel,
  },
};
</script>
